<script lang="ts">
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";

  let {
    errors = null,
  }: {
    errors?: { [key: string]: string } | null;
  } = $props();
</script>

<h2 class="ui-title">One more thing...</h2>

<fieldset class="ui-fieldset">
  <legend class="mb-2">
    We are always researching possible consumer claims. If we find claims you may qualify for, may we contact you to let
    you know about them?
  </legend>

  <div class="ui-option-container">
    <label class="flex flex-row gap-2 items-start">
      <input type="radio" name="account[re_marketing_opt_out]" value="false" class="radio" required>
      <div>Yes, please let me know about future potential claims</div>
    </label>
  </div>

  <div class="ui-option-container">
    <label class="flex flex-row gap-2 items-start">
      <input type="radio" name="account[re_marketing_opt_out]" value="true" class="radio" required>
      <div>No, I don’t want to hear about it</div>
    </label>
  </div>

  {#if errors?.re_marketing_opt_out}<div class="ui-error">{errors.re_marketing_opt_out}</div>{/if}
</fieldset>

<FooterButtons back={false} class="justify-end">
  <ContinueButton />
</FooterButtons>
